import React from 'react';
import classnames from 'classnames/bind';
import { FormField } from 'taboola-ultimate-ui';
import { UserFrequencyCapping } from 'modules/campaigns/modules/common-campaign-form/components/UserFrequencyCapping/UserFrequencyCapping';
import styles from 'modules/campaigns/modules/common-campaign-form/components/UserFrequencyCapping/UserFrequencyCapping.module.scss';
import { UserFrequencyCappingFieldTooltip } from 'modules/campaigns/modules/common-campaign-form/components/UserFrequencyCapping/UserFrequencyCappingFieldTooltip';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { useIsFrequencyCappingPermitted } from './useIsFrequencyCappingPermitted';

const classNameBuilder = classnames.bind(styles);

export const UserFrequencyCappingField = () => {
    if (!useIsFrequencyCappingPermitted()) {
        return null;
    }

    return (
        <FormField
            inputId="userImpressionsAmount"
            label={
                <FormattedMessage
                    id="campaign.editor.UserFrequencyCapping.title"
                    defaultMessage="User Frequency Capping."
                />
            }
            description={
                <FormattedMessage
                    id="campaign.editor.UserFrequencyCapping.description"
                    defaultMessage="Set a preference for how often your ads are shown to the same user."
                />
            }
            helpText={<UserFrequencyCappingFieldTooltip />}
            containerClass={classNameBuilder(styles['header'])}
        >
            <UserFrequencyCapping />
        </FormField>
    );
};

export default UserFrequencyCappingField;
